import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IOrigin } from "../../utils/types/models";

export default createEntityReducer<IOrigin>(Endpoint.Origins, Endpoint.OriginsList);
